import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_106: FaireProductEntity = {
  token: "legacy_prod_abbott-106",
  type: "product",
  name: "Olive Branch Planter",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/9412222dce5ab539bbee70c815e2e3b91b93de1af23acd68ba605e933bd28430.jpeg",
  priceDollars: 24,
  subcategory: "Planters",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_garden-outdoor"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
